// TODO: Типы которые в дальнейшем будут приходить с бека

export enum EBenefitProgram {
  /** Семейная **/
  'Family' = 'family',
  /** Господдержка 2020 **/
  'GovernmentSupport2020' = 'governmentSupport2020',
  /** ИТ-ипотека **/
  'It' = 'it',
  /** ИЖС ХОЗСПОСОБОМ **/
  'IzhsHozsposopom' = 'izhsHozsposopom',
  /** Без программы **/
  'NoProgram' = 'noProgram',
}
export enum ECalculateType {
  /** Стоимость объекта **/
  'CostOfRealEstate' = 'costOfRealEstate',
  /** Доход **/
  'Income' = 'income',
}
export enum EEmploymentType {
  /** Владелец бизнеса **/
  'BusinessOwner' = 'businessOwner',
  /** Полная занятость **/
  'Employee' = 'employee',
  /** ИП **/
  'Entrepreneur' = 'entrepreneur',
  /** Самозанятый **/
  'SelfEmployed' = 'selfEmployed',
}
export enum EIncomeConfirmation {
  /** С подтверждением **/
  'Confirmation' = 'confirmation',
  /** Без подтверждения **/
  'NoConfirmation' = 'noConfirmation',
}
export enum EMortgageType {
  /** Ипотека **/
  'Mortgage' = 'mortgage',
  /** Рефинансирование **/
  'Refinancing' = 'refinancing',
}
export enum EObjectType {
  /** Апартаменты **/
  'Apartments' = 'apartments',
  /** Машиноместо **/
  'CarPlace' = 'carPlace',
  /** Квартира **/
  'Flat' = 'flat',
  /** Дом **/
  'House' = 'house',
}
export enum ERealEstateType {
  /** Строительство дома **/
  'HouseBuilding' = 'houseBuilding',
  /** Новостройка **/
  'NewBuilding' = 'newBuilding',
  /** Вторичка **/
  'Secondary' = 'secondary',
}
